module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /var/www/umem/~/core-js/modules/_html.js
// module id = 51
// module chunks = 0